var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 12 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M.434.674a1.427 1.427 0 0 0 0 2.05l7.242 7.089-7.242 7.089a1.427 1.427 0 0 0 0 2.049 1.503 1.503 0 0 0 2.093 0l8.29-8.114a1.427 1.427 0 0 0 0-2.049L2.526.674a1.503 1.503 0 0 0-2.093 0"
})));
export default SvgArrowRight;